<template>
  <div class="courseInfo">
    <div>
      <div class="yuandian"></div>
    </div>
    <div class="content_box">
      <div class="time">{{myitem.created_at}}</div>
      <div class="content_box">
        <div class="content">
          {{ myitem.content }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "courseInfo",
  props: {
    myitem: {
      type: Object,
      default: () => {
        return {
          camp_user_id: 1,
          content:
            "您已完成第二天的打卡任务，距离活动结束还有2天9小时25分钟，继续加油吧！",
          created_at: "2021-08-15 17:34:29",
        };
      },
    },
  },
};
</script>

<style lang="less" scoped>
.courseInfo {
  padding: 1rem 1.625rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .yuandian {
    margin-right: 1.0625rem;
    width: 0.375rem;
    height: 0.375rem;
    background: #ff6147;
    border-radius: 50%;
  }
  .time {
    font-size: 0.875rem;
    font-family: " Microsoft YaHei";
    font-weight: 400;
    color: #999999;
  }
  .content_box {
    width: 100%;
    height: auto;
    border-bottom: .0625rem solid #eeeeee;
    .content {
      margin-top: 1rem;
      margin-bottom: 1.75rem;
      font-size: 1rem;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #666666;
    }
  }
  .content_box{
    flex: 1;
  }
}
</style>